"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var AppBar = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, children = _a.children, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.position, position = _d === void 0 ? 'fixed' : _d;
    return (react_1.default.createElement(AppBar_1.default, { classes: classes.appBar, position: position, color: color },
        react_1.default.createElement(Toolbar_1.default, { classes: classes.toolbar }, children)));
};
exports.default = AppBar;
